/**
 * Policies API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    middleName?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    zip?: string;
}
/**
 * 
 * @export
 * @interface AddressChangeForOwnerDto
 */
export interface AddressChangeForOwnerDto {
    /**
     * 
     * @type {string}
     * @memberof AddressChangeForOwnerDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressChangeForOwnerDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddressChangeForOwnerDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddressChangeForOwnerDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressChangeForOwnerDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof AddressChangeForOwnerDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof AddressChangeForOwnerDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressChangeForOwnerDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof AddressChangeForOwnerDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {AddressDto}
     * @memberof AddressChangeForOwnerDto
     */
    insuredAddress?: AddressDto;
}
/**
 * 
 * @export
 * @interface AddressChangeForOwnerDtoAllOf
 */
export interface AddressChangeForOwnerDtoAllOf {
    /**
     * 
     * @type {AddressDto}
     * @memberof AddressChangeForOwnerDtoAllOf
     */
    insuredAddress?: AddressDto;
}
/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    fullAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    line3?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    zipCode?: string;
}
/**
 * 
 * @export
 * @interface AgentDto
 */
export interface AgentDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface AgentOfRecordDto
 */
export interface AgentOfRecordDto extends AgentDto {
}
/**
 * 
 * @export
 * @interface AutomaticPremiumLoanProvisionDto
 */
export interface AutomaticPremiumLoanProvisionDto {
    /**
     * 
     * @type {string}
     * @memberof AutomaticPremiumLoanProvisionDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AutomaticPremiumLoanProvisionDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AutomaticPremiumLoanProvisionDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof AutomaticPremiumLoanProvisionDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AutomaticPremiumLoanProvisionDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof AutomaticPremiumLoanProvisionDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof AutomaticPremiumLoanProvisionDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof AutomaticPremiumLoanProvisionDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof AutomaticPremiumLoanProvisionDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {number}
     * @memberof AutomaticPremiumLoanProvisionDto
     */
    currentLoanBalance?: number;
    /**
     * 
     * @type {string}
     * @memberof AutomaticPremiumLoanProvisionDto
     */
    loanInterestRate?: string;
    /**
     * 
     * @type {Date}
     * @memberof AutomaticPremiumLoanProvisionDto
     */
    premiumPaidThroughDate?: Date;
}
/**
 * 
 * @export
 * @interface AutomaticPremiumLoanProvisionDtoAllOf
 */
export interface AutomaticPremiumLoanProvisionDtoAllOf {
    /**
     * 
     * @type {number}
     * @memberof AutomaticPremiumLoanProvisionDtoAllOf
     */
    currentLoanBalance?: number;
    /**
     * 
     * @type {string}
     * @memberof AutomaticPremiumLoanProvisionDtoAllOf
     */
    loanInterestRate?: string;
    /**
     * 
     * @type {Date}
     * @memberof AutomaticPremiumLoanProvisionDtoAllOf
     */
    premiumPaidThroughDate?: Date;
}
/**
 * 
 * @export
 * @interface CommissionAgentDto
 */
export interface CommissionAgentDto {
    /**
     * 
     * @type {string}
     * @memberof CommissionAgentDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof CommissionAgentDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CommissionAgentDto
     */
    commissionPhase?: string;
    /**
     * 
     * @type {string}
     * @memberof CommissionAgentDto
     */
    commissionPercent?: string;
}
/**
 * 
 * @export
 * @interface CommissionAgentDtoAllOf
 */
export interface CommissionAgentDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof CommissionAgentDtoAllOf
     */
    commissionPhase?: string;
    /**
     * 
     * @type {string}
     * @memberof CommissionAgentDtoAllOf
     */
    commissionPercent?: string;
}
/**
 * 
 * @export
 * @interface CorrespondenceLetterSummaryDto
 */
export interface CorrespondenceLetterSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof CorrespondenceLetterSummaryDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof CorrespondenceLetterSummaryDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof CorrespondenceLetterSummaryDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CorrespondenceLetterSummaryDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CorrespondenceLetterSummaryDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof CorrespondenceLetterSummaryDto
     */
    date: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CorrespondenceLetterSummaryDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof CorrespondenceLetterSummaryDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CorrespondenceLetterSummaryDto
     */
    documentKey?: string;
    /**
     * 
     * @type {Array<Link>}
     * @memberof CorrespondenceLetterSummaryDto
     */
    links?: Array<Link>;
}
/**
 * 
 * @export
 * @interface DirectBillingChange
 */
export interface DirectBillingChange {
    /**
     * 
     * @type {PremiumMode}
     * @memberof DirectBillingChange
     */
    premiumMode: PremiumMode;
}
/**
 * 
 * @export
 * @interface Enumeration
 */
export interface Enumeration {
    /**
     * 
     * @type {string}
     * @memberof Enumeration
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Enumeration
     */
    id: number;
}
/**
 * 
 * @export
 * @interface FormLetterDto
 */
export interface FormLetterDto {
    /**
     * 
     * @type {string}
     * @memberof FormLetterDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FormLetterDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormLetterDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof FormLetterDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FormLetterDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof FormLetterDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof FormLetterDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof FormLetterDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof FormLetterDto
     */
    ownerAddress?: AddressDto;
}
/**
 * 
 * @export
 * @interface FormLetterDtoAllOf
 */
export interface FormLetterDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof FormLetterDtoAllOf
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof FormLetterDtoAllOf
     */
    ownerAddress?: AddressDto;
}
/**
 * 
 * @export
 * @interface FuturePurchaseOptionsDto
 */
export interface FuturePurchaseOptionsDto {
    /**
     * 
     * @type {string}
     * @memberof FuturePurchaseOptionsDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FuturePurchaseOptionsDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FuturePurchaseOptionsDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof FuturePurchaseOptionsDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FuturePurchaseOptionsDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof FuturePurchaseOptionsDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof FuturePurchaseOptionsDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof FuturePurchaseOptionsDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof FuturePurchaseOptionsDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof FuturePurchaseOptionsDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof FuturePurchaseOptionsDto
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof FuturePurchaseOptionsDto
     */
    ammount?: number;
    /**
     * 
     * @type {number}
     * @memberof FuturePurchaseOptionsDto
     */
    amountIncrease?: number;
    /**
     * 
     * @type {string}
     * @memberof FuturePurchaseOptionsDto
     */
    frequency?: string;
    /**
     * 
     * @type {number}
     * @memberof FuturePurchaseOptionsDto
     */
    premiumAmount?: number;
}
/**
 * 
 * @export
 * @interface FuturePurchaseOptionsDtoAllOf
 */
export interface FuturePurchaseOptionsDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof FuturePurchaseOptionsDtoAllOf
     */
    accountNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof FuturePurchaseOptionsDtoAllOf
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof FuturePurchaseOptionsDtoAllOf
     */
    ammount?: number;
    /**
     * 
     * @type {number}
     * @memberof FuturePurchaseOptionsDtoAllOf
     */
    amountIncrease?: number;
    /**
     * 
     * @type {string}
     * @memberof FuturePurchaseOptionsDtoAllOf
     */
    frequency?: string;
    /**
     * 
     * @type {number}
     * @memberof FuturePurchaseOptionsDtoAllOf
     */
    premiumAmount?: number;
}
/**
 * 
 * @export
 * @interface Gender
 */
export interface Gender extends Enumeration {
}
/**
 * 
 * @export
 * @interface HealthPlanDto
 */
export interface HealthPlanDto {
    /**
     * 
     * @type {string}
     * @memberof HealthPlanDto
     */
    planCode?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthPlanDto
     */
    planDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthPlanDto
     */
    commonPlan?: string;
    /**
     * 
     * @type {Date}
     * @memberof HealthPlanDto
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof HealthPlanDto
     */
    commissionPhase?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthPlanDto
     */
    issueAge?: string;
    /**
     * 
     * @type {Date}
     * @memberof HealthPlanDto
     */
    terminationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof HealthPlanDto
     */
    coverageType?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthPlanDto
     */
    coverageLevel?: string;
    /**
     * 
     * @type {number}
     * @memberof HealthPlanDto
     */
    units?: number;
    /**
     * 
     * @type {number}
     * @memberof HealthPlanDto
     */
    eliminationPeriodAccident?: number;
    /**
     * 
     * @type {number}
     * @memberof HealthPlanDto
     */
    eliminationPeriodSickness?: number;
    /**
     * 
     * @type {number}
     * @memberof HealthPlanDto
     */
    benefitPeriodAccident?: number;
    /**
     * 
     * @type {number}
     * @memberof HealthPlanDto
     */
    benefitPeriodSickness?: number;
    /**
     * 
     * @type {number}
     * @memberof HealthPlanDto
     */
    employeeContributionPercent?: number;
}
/**
 * 
 * @export
 * @interface ImageSearchResponseDto
 */
export interface ImageSearchResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ImageSearchResponseDto
     */
    status?: string;
    /**
     * 
     * @type {Array<ImagesDto>}
     * @memberof ImageSearchResponseDto
     */
    images?: Array<ImagesDto>;
}
/**
 * 
 * @export
 * @interface ImagesDto
 */
export interface ImagesDto {
    /**
     * 
     * @type {string}
     * @memberof ImagesDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ImagesDto
     */
    documentKey?: string;
    /**
     * 
     * @type {Date}
     * @memberof ImagesDto
     */
    createDate?: Date;
    /**
     * 
     * @type {Array<Link>}
     * @memberof ImagesDto
     */
    links?: Array<Link>;
}
/**
 * 
 * @export
 * @interface InitialPremiumNotReceivedDto
 */
export interface InitialPremiumNotReceivedDto {
    /**
     * 
     * @type {string}
     * @memberof InitialPremiumNotReceivedDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InitialPremiumNotReceivedDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitialPremiumNotReceivedDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof InitialPremiumNotReceivedDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InitialPremiumNotReceivedDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof InitialPremiumNotReceivedDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof InitialPremiumNotReceivedDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof InitialPremiumNotReceivedDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof InitialPremiumNotReceivedDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof InitialPremiumNotReceivedDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof InitialPremiumNotReceivedDto
     */
    dueDate: Date;
    /**
     * 
     * @type {string}
     * @memberof InitialPremiumNotReceivedDto
     */
    agentName?: string;
}
/**
 * 
 * @export
 * @interface InitialPremiumNotReceivedDtoAllOf
 */
export interface InitialPremiumNotReceivedDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof InitialPremiumNotReceivedDtoAllOf
     */
    accountNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof InitialPremiumNotReceivedDtoAllOf
     */
    dueDate: Date;
    /**
     * 
     * @type {string}
     * @memberof InitialPremiumNotReceivedDtoAllOf
     */
    agentName?: string;
}
/**
 * 
 * @export
 * @interface LetterDto
 */
export interface LetterDto {
    /**
     * 
     * @type {string}
     * @memberof LetterDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LetterDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LetterDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof LetterDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LetterDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof LetterDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof LetterDto
     */
    insuredName?: string;
}

export interface Rider {
  riderCode?: string;
  riderName?: string; 
  name?: string;      
  description?: string;
  riderDesc?: string;
  riderAmount?: number;
  effectiveDate?: string | Date;
  terminationDate?: string | Date;
  status?: string;
  planCode?: string;
};
/**
 * 
 * @export
 * @interface LifePlanDto
 */
export interface LifePlanDto {
    /**
     * 
     * @type {string}
     * @memberof LifePlanDto
     */
    planCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LifePlanDto
     */
    riders?: Rider[];
    /**
     * 
     * @type {string}
     * @memberof LifePlanDto
     */
    planDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof LifePlanDto
     */
    commonPlan?: string;
    /**
     * 
     * @type {Date}
     * @memberof LifePlanDto
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof LifePlanDto
     */
    commissionPhase?: string;
    /**
     * 
     * @type {string}
     * @memberof LifePlanDto
     */
    issueAge?: string;
    /**
     * 
     * @type {Date}
     * @memberof LifePlanDto
     */
    terminationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof LifePlanDto
     */
    coverageType?: string;
    /**
     * 
     * @type {string}
     * @memberof LifePlanDto
     */
    coverageLevel?: string;
    /**
     * 
     * @type {number}
     * @memberof LifePlanDto
     */
    amtOfInsurance?: number;
    /**
     * 
     * @type {string}
     * @memberof LifePlanDto
     */
    deathBenefitOption?: string;
    /**
     * 
     * @type {number}
     * @memberof LifePlanDto
     */
    employeeContributionPercent?: number;
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    rel?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    verb?: string;
}
/**
 * 
 * @export
 * @interface LoanPaidInFullDto
 */
export interface LoanPaidInFullDto extends FormLetterDto {
}
/**
 * 
 * @export
 * @interface LocationDto
 */
export interface LocationDto {
    /**
     * 
     * @type {number}
     * @memberof LocationDto
     */
    locationId?: number;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof LocationDto
     */
    effectiveDate?: Date;
}
/**
 * 
 * @export
 * @interface OwnerDto
 */
export interface OwnerDto {
    /**
     * 
     * @type {string}
     * @memberof OwnerDto
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof OwnerDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof OwnerDto
     */
    lastName?: string;
    /**
     * 
     * @type {Date}
     * @memberof OwnerDto
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {string}
     * @memberof OwnerDto
     */
    identifier?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof OwnerDto
     */
    address?: AddressDto;
    /**
     * 
     * @type {Date}
     * @memberof OwnerDto
     */
    hireDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof OwnerDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OwnerDto
     */
    email?: string;
    /**
     * 
     * @type {Gender}
     * @memberof OwnerDto
     */
    gender?: Gender;
}
/**
 * 
 * @export
 * @interface OwnerDtoAllOf
 */
export interface OwnerDtoAllOf {
    /**
     * 
     * @type {Date}
     * @memberof OwnerDtoAllOf
     */
    hireDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof OwnerDtoAllOf
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OwnerDtoAllOf
     */
    email?: string;
    /**
     * 
     * @type {Gender}
     * @memberof OwnerDtoAllOf
     */
    gender?: Gender;
}
/**
 * 
 * @export
 * @interface PagedResultOfCorrespondenceLetterSummaryDto
 */
export interface PagedResultOfCorrespondenceLetterSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfCorrespondenceLetterSummaryDto
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfCorrespondenceLetterSummaryDto
     */
    currentPageNumber: number;
    /**
     * 
     * @type {Array<CorrespondenceLetterSummaryDto>}
     * @memberof PagedResultOfCorrespondenceLetterSummaryDto
     */
    result?: Array<CorrespondenceLetterSummaryDto>;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfCorrespondenceLetterSummaryDto
     */
    links?: Array<Link>;
}
/**
 * 
 * @export
 * @interface PagedResultOfPolicyApplicationDto
 */
export interface PagedResultOfPolicyApplicationDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfPolicyApplicationDto
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfPolicyApplicationDto
     */
    currentPageNumber: number;
    /**
     * 
     * @type {Array<PolicyApplicationDto>}
     * @memberof PagedResultOfPolicyApplicationDto
     */
    result?: Array<PolicyApplicationDto>;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfPolicyApplicationDto
     */
    links?: Array<Link>;
}
/**
 * 
 * @export
 * @interface PagedResultOfPolicyDto
 */
export interface PagedResultOfPolicyDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfPolicyDto
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfPolicyDto
     */
    currentPageNumber: number;
    /**
     * 
     * @type {Array<PolicyDto>}
     * @memberof PagedResultOfPolicyDto
     */
    result?: Array<PolicyDto>;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfPolicyDto
     */
    links?: Array<Link>;
}
/**
 * 
 * @export
 * @interface PayrollAllotmentChange
 */
export interface PayrollAllotmentChange {
    /**
     * 
     * @type {string}
     * @memberof PayrollAllotmentChange
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PayrollAllotmentChange
     */
    controlNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PayrollAllotmentChange
     */
    payorName?: string;
    /**
     * 
     * @type {PremiumMode}
     * @memberof PayrollAllotmentChange
     */
    premiumMode: PremiumMode;
}
/**
 * 
 * @export
 * @interface PendingUnderwritingRequirementDto
 */
export interface PendingUnderwritingRequirementDto {
    /**
     * 
     * @type {string}
     * @memberof PendingUnderwritingRequirementDto
     */
    accountName?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingUnderwritingRequirementDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingUnderwritingRequirementDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingUnderwritingRequirementDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingUnderwritingRequirementDto
     */
    plan?: string;
    /**
     * 
     * @type {number}
     * @memberof PendingUnderwritingRequirementDto
     */
    premium?: number;
    /**
     * 
     * @type {Date}
     * @memberof PendingUnderwritingRequirementDto
     */
    dateRequested?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PendingUnderwritingRequirementDto
     */
    statusDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof PendingUnderwritingRequirementDto
     */
    requirementId: number;
    /**
     * 
     * @type {string}
     * @memberof PendingUnderwritingRequirementDto
     */
    details?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingUnderwritingRequirementDto
     */
    groupName?: string;
}
/**
 * 
 * @export
 * @interface PersonDto
 */
export interface PersonDto {
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    lastName?: string;
    /**
     * 
     * @type {Date}
     * @memberof PersonDto
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    identifier?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof PersonDto
     */
    address?: AddressDto;
}

/**
 *
 * @export
 * @interface PolicyApplicationRecordInfoDTO
 */
export interface PolicyApplicationRecordInfoDTO {
    /**
     *
     * @type {number}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    annualPremium?: number;
    /**
     *
     * @type {number}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    deductionAmount?: number;
    /**
     *
     * @type {string}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    insuredName?: string;
    /**
     *
     * @type {string}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    insuredIdentifier?: string;
    /**
     *
     * @type {string}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    planName?: string;
    /**
     *
     * @type {string}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    premiumMode?: string;
    /**
     *
     * @type {string}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    relation?: string;
    /**
     *
     * @type {string}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    writingAgent?: string;
    /**
     *
     * @type {string}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    writingAgentNumber?: string;
    /**
     *
     * @type {Date}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    dateAppSigned?: Date;
    /**
     *
     * @type {Date}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    submissionDate?: Date;
    /**
     *
     * @type {Date}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    originalDate?: Date;
    /**
     *
     * @type {PolicyApplicationStatus}
     * @memberof PolicyApplicationRecordInfoDTO
     */
    status?: PolicyApplicationStatus;
  }

/**
 * 
 * @export
 * @interface PolicyApplicationDto
 */
export interface PolicyApplicationDto {
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    appId?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    planName?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    premiumMode?: string;
    /**
     * 
     * @type {number}
     * @memberof PolicyApplicationDto
     */
    deductionAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyApplicationDto
     */
    annualDeduction?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    employeeName?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    employeeIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    insuredIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    relation?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    writingAgentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    writingAgent?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyApplicationDto
     */
    imageExists: boolean;
    /**
     * 
     * @type {string}
     * @memberof PolicyApplicationDto
     */
    employerName?: string;
    /**
     * 
     * @type {Date}
     * @memberof PolicyApplicationDto
     */
    dateTransmitted?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PolicyApplicationDto
     */
    signatureDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PolicyApplicationDto
     */
    originalDate?: Date;
    /**
     * 
     * @type {PolicyApplicationSource}
     * @memberof PolicyApplicationDto
     */
    sourceType?: PolicyApplicationSource;
    /**
     * 
     * @type {PolicyApplicationStatus}
     * @memberof PolicyApplicationDto
     */
    status?: PolicyApplicationStatus;
    /**
     * 
     * @type {Source}
     * @memberof PolicyApplicationDto
     */
    source?: Source;
    /**
     * 
     * @type {Link}
     * @memberof PolicyApplicationDto
     */
    link?: Link;
    /**
     * 
     * @type {Array<PolicyApplicationRecordInfoDTO>}
     * @memberof PolicyApplicationDto
     */
    recordInfo?: Array<PolicyApplicationRecordInfoDTO>
     /**
     * 
     * @type {boolean}
     * @memberof PolicyApplicationDto
     */
    eisFlag?: boolean
}
/**
 * 
 * @export
 * @interface PolicyApplicationSource
 */
export interface PolicyApplicationSource extends Enumeration {
}
/**
 * 
 * @export
 * @interface PolicyApplicationStatus
 */
export interface PolicyApplicationStatus extends Enumeration {
}
/**
 * 
 * @export
 * @interface PolicyDetailDto
 */
export interface PolicyDetailDto {
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    accountName?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    previousAccountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    previousAccountName?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    policyType?: string;
    /**
     * 
     * @type {Date}
     * @memberof PolicyDetailDto
     */
    issueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    payorName?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    last4PayorNumber?: string;
    /**
     * 
     * @type {PersonDto}
     * @memberof PolicyDetailDto
     */
    insured?: PersonDto;
    /**
     * 
     * @type {OwnerDto}
     * @memberof PolicyDetailDto
     */
    owner?: OwnerDto;
    /**
     * 
     * @type {Array<HealthPlanDto>}
     * @memberof PolicyDetailDto
     */
    healthPlans?: Array<HealthPlanDto>;
    /**
     * 
     * @type {Array<LifePlanDto>}
     * @memberof PolicyDetailDto
     */
    lifePlans?: Array<LifePlanDto>;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    mode?: string;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailDto
     */
    premium?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailDto
     */
    billingPremium?: number;
    /**
     * 
     * @type {Date}
     * @memberof PolicyDetailDto
     */
    lastPayDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PolicyDetailDto
     */
    terminationDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof PolicyDetailDto
     */
    lastPayAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    specialHandlingInstruction?: string;
    /**
     * 
     * @type {ServicingAgentDto}
     * @memberof PolicyDetailDto
     */
    servicingAgent?: ServicingAgentDto;
    /**
     * 
     * @type {AgentOfRecordDto}
     * @memberof PolicyDetailDto
     */
    agentOfRecord?: AgentOfRecordDto;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetailDto
     */
    groupNumber?: string;
    /**
     * 
     * @type {LocationDto}
     * @memberof PolicyDetailDto
     */
    location?: LocationDto;
    /**
     * 
     * @type {Array<CommissionAgentDto>}
     * @memberof PolicyDetailDto
     */
    commissionAgents?: Array<CommissionAgentDto>;
    /**
     * 
     * @type {Source}
     * @memberof PolicyDetailDto
     */
    source?: Source;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyDetailDto
     */
     eisFlag: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyDto
     */
    wellnessCoverage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyDto
     */
    optCoverage?: boolean;
}
/**
 * 
 * @export
 * @interface PolicyDto
 */
export interface PolicyDto {
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    accountName?: string;
    /**
     * 
     *        @type {string}
     * @memberof PolicyDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    policyType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyDto
     */
    wellnessCoverage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyDto
     */
    optCoverage?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    payorName?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    insuredName?: string;
    /**
     * 
     * @type {number}
     * @memberof PolicyDto
     */
    premium?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof PolicyDto
     */
    issueDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PolicyDto
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    last4PayorNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    ownerLast4OfSSN?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    ownerName?: string;
    /**
     * 
     * @type {Date}
     * @memberof PolicyDto
     */
    ownerDateOfBirth?: Date;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    ownerPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    ownerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDto
     */
    ownerAddress?: string;
    /**
     * 
     * @type {Source}
     * @memberof PolicyDto
     */
    source?: Source;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PolicyDto
     */
    links?: Array<Link>;
      /**0i9
     * 
     * @type {boolean}
     * @memberof PolicyDto
     */
       eisFlag: boolean | null;
}
/**
 * 
 * @export
 * @interface PolicyLapseADto
 */
export interface PolicyLapseADto {
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseADto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseADto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyLapseADto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseADto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseADto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof PolicyLapseADto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseADto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseADto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof PolicyLapseADto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseADto
     */
    coverageType?: string;
    /**
     * 
     * @type {Date}
     * @memberof PolicyLapseADto
     */
    coverageCeaseDate: Date;
}
/**
 * 
 * @export
 * @interface PolicyLapseADtoAllOf
 */
export interface PolicyLapseADtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseADtoAllOf
     */
    coverageType?: string;
    /**
     * 
     * @type {Date}
     * @memberof PolicyLapseADtoAllOf
     */
    coverageCeaseDate: Date;
}
/**
 * 
 * @export
 * @interface PolicyLapseDto
 */
export interface PolicyLapseDto {
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyLapseDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof PolicyLapseDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof PolicyLapseDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseDto
     */
    coverageType?: string;
    /**
     * 
     * @type {Date}
     * @memberof PolicyLapseDto
     */
    coverageCeaseDate: Date;
    /**
     * 
     * @type {number}
     * @memberof PolicyLapseDto
     */
    reinstatementAmountDue: number;
}
/**
 * 
 * @export
 * @interface PolicyLapseDtoAllOf
 */
export interface PolicyLapseDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof PolicyLapseDtoAllOf
     */
    coverageType?: string;
    /**
     * 
     * @type {Date}
     * @memberof PolicyLapseDtoAllOf
     */
    coverageCeaseDate: Date;
    /**
     * 
     * @type {number}
     * @memberof PolicyLapseDtoAllOf
     */
    reinstatementAmountDue: number;
}
/**
 * 
 * @export
 * @interface PolicyPreLapseDto
 */
export interface PolicyPreLapseDto extends FormLetterDto {
}
/**
 * 
 * @export
 * @interface PremiumChangeDueToExpiryOfSupplementBenefitDto
 */
export interface PremiumChangeDueToExpiryOfSupplementBenefitDto {
    /**
     * 
     * @type {string}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {Date}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDto
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDto
     */
    newPremium?: number;
}
/**
 * 
 * @export
 * @interface PremiumChangeDueToExpiryOfSupplementBenefitDtoAllOf
 */
export interface PremiumChangeDueToExpiryOfSupplementBenefitDtoAllOf {
    /**
     * 
     * @type {Date}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDtoAllOf
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof PremiumChangeDueToExpiryOfSupplementBenefitDtoAllOf
     */
    newPremium?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PremiumMode {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4
}

/**
 * 
 * @export
 * @interface PremiumNoticeAFDto
 */
export interface PremiumNoticeAFDto {
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeAFDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeAFDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumNoticeAFDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeAFDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeAFDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof PremiumNoticeAFDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeAFDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeAFDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof PremiumNoticeAFDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeAFDto
     */
    coverageType?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeAFDto
     */
    numberOfMonthsTillDue?: string;
    /**
     * 
     * @type {Date}
     * @memberof PremiumNoticeAFDto
     */
    dueDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof PremiumNoticeAFDto
     */
    amountDue?: number;
}
/**
 * 
 * @export
 * @interface PremiumNoticeAFDtoAllOf
 */
export interface PremiumNoticeAFDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeAFDtoAllOf
     */
    coverageType?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeAFDtoAllOf
     */
    numberOfMonthsTillDue?: string;
    /**
     * 
     * @type {Date}
     * @memberof PremiumNoticeAFDtoAllOf
     */
    dueDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof PremiumNoticeAFDtoAllOf
     */
    amountDue?: number;
}
/**
 * 
 * @export
 * @interface PremiumNoticeDto
 */
export interface PremiumNoticeDto {
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumNoticeDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof PremiumNoticeDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof PremiumNoticeDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeDto
     */
    coverageType?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeDto
     */
    numberOfMonthsTillDue?: string;
    /**
     * 
     * @type {Date}
     * @memberof PremiumNoticeDto
     */
    dueDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof PremiumNoticeDto
     */
    amountDue?: number;
    /**
     * 
     * @type {number}
     * @memberof PremiumNoticeDto
     */
    totalDue?: number;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeDto
     */
    payable?: string;
}
/**
 * 
 * @export
 * @interface PremiumNoticeDtoAllOf
 */
export interface PremiumNoticeDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeDtoAllOf
     */
    coverageType?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeDtoAllOf
     */
    numberOfMonthsTillDue?: string;
    /**
     * 
     * @type {Date}
     * @memberof PremiumNoticeDtoAllOf
     */
    dueDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof PremiumNoticeDtoAllOf
     */
    amountDue?: number;
    /**
     * 
     * @type {number}
     * @memberof PremiumNoticeDtoAllOf
     */
    totalDue?: number;
    /**
     * 
     * @type {string}
     * @memberof PremiumNoticeDtoAllOf
     */
    payable?: string;
}
/**
 * 
 * @export
 * @interface PremiumPaidUpDto
 */
export interface PremiumPaidUpDto extends FormLetterDto {
}
/**
 * 
 * @export
 * @interface ProcessLogDto
 */
export interface ProcessLogDto {
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    processName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    machineName?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProcessLogDto
     */
    etlLoadStartDateTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProcessLogDto
     */
    etlLoadEndDateTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    elapsedTime?: string;
}
/**
 * 
 * @export
 * @interface RenewableTermPolicyPremiumChangeDto
 */
export interface RenewableTermPolicyPremiumChangeDto {
    /**
     * 
     * @type {string}
     * @memberof RenewableTermPolicyPremiumChangeDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RenewableTermPolicyPremiumChangeDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RenewableTermPolicyPremiumChangeDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof RenewableTermPolicyPremiumChangeDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof RenewableTermPolicyPremiumChangeDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof RenewableTermPolicyPremiumChangeDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof RenewableTermPolicyPremiumChangeDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof RenewableTermPolicyPremiumChangeDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof RenewableTermPolicyPremiumChangeDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {number}
     * @memberof RenewableTermPolicyPremiumChangeDto
     */
    currentPremium?: number;
    /**
     * 
     * @type {Date}
     * @memberof RenewableTermPolicyPremiumChangeDto
     */
    renewalDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof RenewableTermPolicyPremiumChangeDto
     */
    newPremium?: number;
}
/**
 * 
 * @export
 * @interface RenewableTermPolicyPremiumChangeDtoAllOf
 */
export interface RenewableTermPolicyPremiumChangeDtoAllOf {
    /**
     * 
     * @type {number}
     * @memberof RenewableTermPolicyPremiumChangeDtoAllOf
     */
    currentPremium?: number;
    /**
     * 
     * @type {Date}
     * @memberof RenewableTermPolicyPremiumChangeDtoAllOf
     */
    renewalDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof RenewableTermPolicyPremiumChangeDtoAllOf
     */
    newPremium?: number;
}
/**
 * 
 * @export
 * @interface RequestToCancelDto
 */
export interface RequestToCancelDto {
    /**
     * 
     * @type {string}
     * @memberof RequestToCancelDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestToCancelDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RequestToCancelDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof RequestToCancelDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestToCancelDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof RequestToCancelDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof RequestToCancelDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestToCancelDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof RequestToCancelDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof RequestToCancelDto
     */
    accountNumber?: string;
}
/**
 * 
 * @export
 * @interface RequestToCancelDtoAllOf
 */
export interface RequestToCancelDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof RequestToCancelDtoAllOf
     */
    accountNumber?: string;
}
/**
 * 
 * @export
 * @interface ReturnedPaymentDto
 */
export interface ReturnedPaymentDto {
    /**
     * 
     * @type {string}
     * @memberof ReturnedPaymentDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedPaymentDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReturnedPaymentDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReturnedPaymentDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedPaymentDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof ReturnedPaymentDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof ReturnedPaymentDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedPaymentDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof ReturnedPaymentDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof ReturnedPaymentDto
     */
    bankNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedPaymentDto
     */
    amountReturned?: number;
}
/**
 * 
 * @export
 * @interface ReturnedPaymentDtoAllOf
 */
export interface ReturnedPaymentDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof ReturnedPaymentDtoAllOf
     */
    bankNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedPaymentDtoAllOf
     */
    amountReturned?: number;
}
/**
 * 
 * @export
 * @interface Section125CancellationConfirmationDto
 */
export interface Section125CancellationConfirmationDto {
    /**
     * 
     * @type {string}
     * @memberof Section125CancellationConfirmationDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Section125CancellationConfirmationDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Section125CancellationConfirmationDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof Section125CancellationConfirmationDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Section125CancellationConfirmationDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof Section125CancellationConfirmationDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof Section125CancellationConfirmationDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof Section125CancellationConfirmationDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof Section125CancellationConfirmationDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof Section125CancellationConfirmationDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Section125CancellationConfirmationDto
     */
    accountName?: string;
}
/**
 * 
 * @export
 * @interface Section125CancellationConfirmationDtoAllOf
 */
export interface Section125CancellationConfirmationDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof Section125CancellationConfirmationDtoAllOf
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Section125CancellationConfirmationDtoAllOf
     */
    accountName?: string;
}
/**
 * 
 * @export
 * @interface SendPolicyServiceRequestChangeCommand
 */
export interface SendPolicyServiceRequestChangeCommand {
    /**
     * 
     * @type {string}
     * @memberof SendPolicyServiceRequestChangeCommand
     */
    policyNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SendPolicyServiceRequestChangeCommand
     */
    additionalPolicyNumbers?: string;
    /**
     * 
     * @type {string}
     * @memberof SendPolicyServiceRequestChangeCommand
     */
    insuredFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof SendPolicyServiceRequestChangeCommand
     */
    insuredMiddleName?: string;
    /**
     * 
     * @type {string}
     * @memberof SendPolicyServiceRequestChangeCommand
     */
    insuredLastName?: string;
    /**
     * 
     * @type {Address}
     * @memberof SendPolicyServiceRequestChangeCommand
     */
    address?: Address;
    /**
     * 
     * @type {PayrollAllotmentChange}
     * @memberof SendPolicyServiceRequestChangeCommand
     */
    payrollAllotmentChange?: PayrollAllotmentChange;
    /**
     * 
     * @type {DirectBillingChange}
     * @memberof SendPolicyServiceRequestChangeCommand
     */
    directBillingChange?: DirectBillingChange;
}
/**
 * 
 * @export
 * @interface ServicingAgentDto
 */
export interface ServicingAgentDto extends AgentDto {
}
/**
 * 
 * @export
 * @interface Source
 */
export interface Source extends Enumeration {
}
/**
 * 
 * @export
 * @interface UniversalLifeGraceLetterAFDto
 */
export interface UniversalLifeGraceLetterAFDto {
    /**
     * 
     * @type {string}
     * @memberof UniversalLifeGraceLetterAFDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UniversalLifeGraceLetterAFDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UniversalLifeGraceLetterAFDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof UniversalLifeGraceLetterAFDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UniversalLifeGraceLetterAFDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof UniversalLifeGraceLetterAFDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof UniversalLifeGraceLetterAFDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof UniversalLifeGraceLetterAFDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof UniversalLifeGraceLetterAFDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {number}
     * @memberof UniversalLifeGraceLetterAFDto
     */
    premiumDue?: number;
}
/**
 * 
 * @export
 * @interface UniversalLifeGraceLetterAFDtoAllOf
 */
export interface UniversalLifeGraceLetterAFDtoAllOf {
    /**
     * 
     * @type {number}
     * @memberof UniversalLifeGraceLetterAFDtoAllOf
     */
    premiumDue?: number;
}
/**
 * 
 * @export
 * @interface UniversalLifeGraceLetterDto
 */
export interface UniversalLifeGraceLetterDto {
    /**
     * 
     * @type {string}
     * @memberof UniversalLifeGraceLetterDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UniversalLifeGraceLetterDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UniversalLifeGraceLetterDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof UniversalLifeGraceLetterDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UniversalLifeGraceLetterDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof UniversalLifeGraceLetterDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof UniversalLifeGraceLetterDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof UniversalLifeGraceLetterDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof UniversalLifeGraceLetterDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {number}
     * @memberof UniversalLifeGraceLetterDto
     */
    minimumPaymentDue?: number;
    /**
     * 
     * @type {Date}
     * @memberof UniversalLifeGraceLetterDto
     */
    paymentDueDate?: Date;
}
/**
 * 
 * @export
 * @interface UniversalLifeGraceLetterDtoAllOf
 */
export interface UniversalLifeGraceLetterDtoAllOf {
    /**
     * 
     * @type {number}
     * @memberof UniversalLifeGraceLetterDtoAllOf
     */
    minimumPaymentDue?: number;
    /**
     * 
     * @type {Date}
     * @memberof UniversalLifeGraceLetterDtoAllOf
     */
    paymentDueDate?: Date;
}
/**
 * 
 * @export
 * @interface WithholdingFromLoanOrPartialWithdrawalsDto
 */
export interface WithholdingFromLoanOrPartialWithdrawalsDto {
    /**
     * 
     * @type {string}
     * @memberof WithholdingFromLoanOrPartialWithdrawalsDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WithholdingFromLoanOrPartialWithdrawalsDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WithholdingFromLoanOrPartialWithdrawalsDto
     */
    isNewYork: boolean;
    /**
     * 
     * @type {string}
     * @memberof WithholdingFromLoanOrPartialWithdrawalsDto
     */
    agentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WithholdingFromLoanOrPartialWithdrawalsDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof WithholdingFromLoanOrPartialWithdrawalsDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof WithholdingFromLoanOrPartialWithdrawalsDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof WithholdingFromLoanOrPartialWithdrawalsDto
     */
    ownerName?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof WithholdingFromLoanOrPartialWithdrawalsDto
     */
    ownerAddress?: AddressDto;
    /**
     * 
     * @type {number}
     * @memberof WithholdingFromLoanOrPartialWithdrawalsDto
     */
    withheldAmount?: number;
}
/**
 * 
 * @export
 * @interface WithholdingFromLoanOrPartialWithdrawalsDtoAllOf
 */
export interface WithholdingFromLoanOrPartialWithdrawalsDtoAllOf {
    /**
     * 
     * @type {number}
     * @memberof WithholdingFromLoanOrPartialWithdrawalsDtoAllOf
     */
    withheldAmount?: number;
}

/**
 * CorrespondenceDetailsApi - axios parameter creator
 * @export
 */
export const CorrespondenceDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorrespondenceDetails(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getCorrespondenceDetails.');
            }
            const localVarPath = `/api/policies/v{version}/correspondences/details`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CorrespondenceDetailsApi - functional programming interface
 * @export
 */
export const CorrespondenceDetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorrespondenceDetails(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormLetterDto> {
            const localVarAxiosArgs = CorrespondenceDetailsApiAxiosParamCreator(configuration).getCorrespondenceDetails(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CorrespondenceDetailsApi - factory interface
 * @export
 */
export const CorrespondenceDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorrespondenceDetails(version: string, options?: any): AxiosPromise<FormLetterDto> {
            return CorrespondenceDetailsApiFp(configuration).getCorrespondenceDetails(version, options)(axios, basePath);
        },
    };
};

/**
 * CorrespondenceDetailsApi - object-oriented interface
 * @export
 * @class CorrespondenceDetailsApi
 * @extends {BaseAPI}
 */
export class CorrespondenceDetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondenceDetailsApi
     */
    public getCorrespondenceDetails(version: string, options?: any) {
        return CorrespondenceDetailsApiFp(this.configuration).getCorrespondenceDetails(version, options)(this.axios, this.basePath);
    }

}


/**
 * CorrespondencesApi - axios parameter creator
 * @export
 */
export const CorrespondencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        correspondencesCorrespondenceETL(version: string, sourceId?: number, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling correspondencesCorrespondenceETL.');
            }
            const localVarPath = `/api/policies/v{version}/correspondences/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['sourceId'] = sourceId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        correspondencesCorrespondenceResetETL(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling correspondencesCorrespondenceResetETL.');
            }
            const localVarPath = `/api/policies/v{version}/correspondences/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorrespondenceLetter(id: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCorrespondenceLetter.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getCorrespondenceLetter.');
            }
            const localVarPath = `/api/policies/v{version}/correspondences/{id}/document`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCorrespondenceLetters(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchCorrespondenceLetters.');
            }
            const localVarPath = `/api/policies/v{version}/correspondences`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CorrespondencesApi - functional programming interface
 * @export
 */
export const CorrespondencesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        correspondencesCorrespondenceETL(version: string, sourceId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CorrespondencesApiAxiosParamCreator(configuration).correspondencesCorrespondenceETL(version, sourceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        correspondencesCorrespondenceResetETL(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CorrespondencesApiAxiosParamCreator(configuration).correspondencesCorrespondenceResetETL(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorrespondenceLetter(id: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = CorrespondencesApiAxiosParamCreator(configuration).getCorrespondenceLetter(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCorrespondenceLetters(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfCorrespondenceLetterSummaryDto> {
            const localVarAxiosArgs = CorrespondencesApiAxiosParamCreator(configuration).searchCorrespondenceLetters(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CorrespondencesApi - factory interface
 * @export
 */
export const CorrespondencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        correspondencesCorrespondenceETL(version: string, sourceId?: number, options?: any): AxiosPromise<void> {
            return CorrespondencesApiFp(configuration).correspondencesCorrespondenceETL(version, sourceId, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        correspondencesCorrespondenceResetETL(version: string, options?: any): AxiosPromise<void> {
            return CorrespondencesApiFp(configuration).correspondencesCorrespondenceResetETL(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorrespondenceLetter(id: string, version: string, options?: any): AxiosPromise<string> {
            return CorrespondencesApiFp(configuration).getCorrespondenceLetter(id, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCorrespondenceLetters(version: string, options?: any): AxiosPromise<PagedResultOfCorrespondenceLetterSummaryDto> {
            return CorrespondencesApiFp(configuration).searchCorrespondenceLetters(version, options)(axios, basePath);
        },
    };
};

/**
 * CorrespondencesApi - object-oriented interface
 * @export
 * @class CorrespondencesApi
 * @extends {BaseAPI}
 */
export class CorrespondencesApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {number} [sourceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondencesApi
     */
    public correspondencesCorrespondenceETL(version: string, sourceId?: number, options?: any) {
        return CorrespondencesApiFp(this.configuration).correspondencesCorrespondenceETL(version, sourceId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondencesApi
     */
    public correspondencesCorrespondenceResetETL(version: string, options?: any) {
        return CorrespondencesApiFp(this.configuration).correspondencesCorrespondenceResetETL(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondencesApi
     */
    public getCorrespondenceLetter(id: string, version: string, options?: any) {
        return CorrespondencesApiFp(this.configuration).getCorrespondenceLetter(id, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondencesApi
     */
    public searchCorrespondenceLetters(version: string, options?: any) {
        return CorrespondencesApiFp(this.configuration).searchCorrespondenceLetters(version, options)(this.axios, this.basePath);
    }

}


/**
 * DetailsApi - axios parameter creator
 * @export
 */
export const DetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyById(id: string, policyNumber: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getPolicyById.');
            }
            // verify required parameter 'policyNumber' is not null or undefined
            if (policyNumber === null || policyNumber === undefined) {
                throw new RequiredError('policyNumber','Required parameter policyNumber was null or undefined when calling getPolicyById.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getPolicyById.');
            }
            const localVarPath = `/api/policies/v{version}/{id}/policyNumber/{policyNumber}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"policyNumber"}}`, encodeURIComponent(String(policyNumber)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DetailsApi - functional programming interface
 * @export
 */
export const DetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyById(id: string, policyNumber: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyDetailDto> {
            const localVarAxiosArgs = DetailsApiAxiosParamCreator(configuration).getPolicyById(id, policyNumber, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DetailsApi - factory interface
 * @export
 */
export const DetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} policyNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyById(id: string, policyNumber: string, version: string, options?: any): AxiosPromise<PolicyDetailDto> {
            return DetailsApiFp(configuration).getPolicyById(id, policyNumber, version, options)(axios, basePath);
        },
    };
};

/**
 * DetailsApi - object-oriented interface
 * @export
 * @class DetailsApi
 * @extends {BaseAPI}
 */
export class DetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} policyNumber 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetailsApi
     */
    public getPolicyById(id: string, policyNumber: string, version: string, options?: any) {
        return DetailsApiFp(this.configuration).getPolicyById(id, policyNumber, version, options)(this.axios, this.basePath);
    }

}


/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [policyNumber] 
         * @param {number} [policyUploadDocumentId] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPolicyDocument(id: string, version: string, policyNumber?: string, policyUploadDocumentId?: number, file?: any, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling uploadPolicyDocument.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling uploadPolicyDocument.');
            }
            const localVarPath = `/api/policies/v{version}/{id}/document/upload`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (policyNumber !== undefined) { 
                localVarFormParams.append('PolicyNumber', policyNumber as any);
            }
    
            if (policyUploadDocumentId !== undefined) { 
                localVarFormParams.append('PolicyUploadDocumentId', policyUploadDocumentId as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [policyNumber] 
         * @param {number} [policyUploadDocumentId] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPolicyDocument(id: string, version: string, policyNumber?: string, policyUploadDocumentId?: number, file?: any, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).uploadPolicyDocument(id, version, policyNumber, policyUploadDocumentId, file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [policyNumber] 
         * @param {number} [policyUploadDocumentId] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPolicyDocument(id: string, version: string, policyNumber?: string, policyUploadDocumentId?: number, file?: any, options?: any): AxiosPromise<string> {
            return DocumentApiFp(configuration).uploadPolicyDocument(id, version, policyNumber, policyUploadDocumentId, file, options)(axios, basePath);
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {string} [policyNumber] 
     * @param {number} [policyUploadDocumentId] 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public uploadPolicyDocument(id: string, version: string, policyNumber?: string, policyUploadDocumentId?: number, file?: any, options?: any) {
        return DocumentApiFp(this.configuration).uploadPolicyDocument(id, version, policyNumber, policyUploadDocumentId, file, options)(this.axios, this.basePath);
    }

}


/**
 * HeartbeatApi - axios parameter creator
 * @export
 */
export const HeartbeatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling heartbeatGet.');
            }
            const localVarPath = `/api/policies/v{version}/heartbeat`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeartbeatApi - functional programming interface
 * @export
 */
export const HeartbeatApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = HeartbeatApiAxiosParamCreator(configuration).heartbeatGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HeartbeatApi - factory interface
 * @export
 */
export const HeartbeatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): AxiosPromise<void> {
            return HeartbeatApiFp(configuration).heartbeatGet(version, options)(axios, basePath);
        },
    };
};

/**
 * HeartbeatApi - object-oriented interface
 * @export
 * @class HeartbeatApi
 * @extends {BaseAPI}
 */
export class HeartbeatApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeartbeatApi
     */
    public heartbeatGet(version: string, options?: any) {
        return HeartbeatApiFp(this.configuration).heartbeatGet(version, options)(this.axios, this.basePath);
    }

}


/**
 * ImagesApi - axios parameter creator
 * @export
 */
export const ImagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} documentKey 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyImageByDocumentKey(documentKey: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'documentKey' is not null or undefined
            if (documentKey === null || documentKey === undefined) {
                throw new RequiredError('documentKey','Required parameter documentKey was null or undefined when calling getPolicyImageByDocumentKey.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getPolicyImageByDocumentKey.');
            }
            const localVarPath = `/api/policies/v{version}/images/{documentKey}`
                .replace(`{${"documentKey"}}`, encodeURIComponent(String(documentKey)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyImageById(id: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getPolicyImageById.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getPolicyImageById.');
            }
            const localVarPath = `/api/policies/v{version}/{id}/images`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImagesApi - functional programming interface
 * @export
 */
export const ImagesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} documentKey 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyImageByDocumentKey(documentKey: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ImagesApiAxiosParamCreator(configuration).getPolicyImageByDocumentKey(documentKey, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyImageById(id: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageSearchResponseDto> {
            const localVarAxiosArgs = ImagesApiAxiosParamCreator(configuration).getPolicyImageById(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ImagesApi - factory interface
 * @export
 */
export const ImagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} documentKey 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyImageByDocumentKey(documentKey: string, version: string, options?: any): AxiosPromise<string> {
            return ImagesApiFp(configuration).getPolicyImageByDocumentKey(documentKey, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyImageById(id: string, version: string, options?: any): AxiosPromise<ImageSearchResponseDto> {
            return ImagesApiFp(configuration).getPolicyImageById(id, version, options)(axios, basePath);
        },
    };
};

/**
 * ImagesApi - object-oriented interface
 * @export
 * @class ImagesApi
 * @extends {BaseAPI}
 */
export class ImagesApi extends BaseAPI {
    /**
     * 
     * @param {string} documentKey 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public getPolicyImageByDocumentKey(documentKey: string, version: string, options?: any) {
        return ImagesApiFp(this.configuration).getPolicyImageByDocumentKey(documentKey, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public getPolicyImageById(id: string, version: string, options?: any) {
        return ImagesApiFp(this.configuration).getPolicyImageById(id, version, options)(this.axios, this.basePath);
    }

}


/**
 * PendingUnderwritingRequirementsApi - axios parameter creator
 * @export
 */
export const PendingUnderwritingRequirementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {Array<string>} [agentNumbers] 
         * @param {boolean} [isNewYork] 
         * @param {boolean} [exportToCsv] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingUnderwritingRequirements(version: string, agentNumbers?: Array<string>, isNewYork?: boolean, exportToCsv?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getPendingUnderwritingRequirements.');
            }
            const localVarPath = `/api/policies/v{version}/underwritingrequirement/pending/summary`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (agentNumbers) {
                localVarQueryParameter['agentNumbers'] = agentNumbers;
            }

            if (isNewYork !== undefined) {
                localVarQueryParameter['isNewYork'] = isNewYork;
            }

            if (exportToCsv !== undefined) {
                localVarQueryParameter['exportToCsv'] = exportToCsv;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pendingUnderwritingRequirementsPendingUnderwritingRequirementResetETL(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling pendingUnderwritingRequirementsPendingUnderwritingRequirementResetETL.');
            }
            const localVarPath = `/api/policies/v{version}/underwritingrequirement/pending/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PendingUnderwritingRequirementsApi - functional programming interface
 * @export
 */
export const PendingUnderwritingRequirementsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {Array<string>} [agentNumbers] 
         * @param {boolean} [isNewYork] 
         * @param {boolean} [exportToCsv] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingUnderwritingRequirements(version: string, agentNumbers?: Array<string>, isNewYork?: boolean, exportToCsv?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PendingUnderwritingRequirementDto>> {
            const localVarAxiosArgs = PendingUnderwritingRequirementsApiAxiosParamCreator(configuration).getPendingUnderwritingRequirements(version, agentNumbers, isNewYork, exportToCsv, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pendingUnderwritingRequirementsPendingUnderwritingRequirementResetETL(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = PendingUnderwritingRequirementsApiAxiosParamCreator(configuration).pendingUnderwritingRequirementsPendingUnderwritingRequirementResetETL(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PendingUnderwritingRequirementsApi - factory interface
 * @export
 */
export const PendingUnderwritingRequirementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {Array<string>} [agentNumbers] 
         * @param {boolean} [isNewYork] 
         * @param {boolean} [exportToCsv] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingUnderwritingRequirements(version: string, agentNumbers?: Array<string>, isNewYork?: boolean, exportToCsv?: boolean, options?: any): AxiosPromise<Array<PendingUnderwritingRequirementDto>> {
            return PendingUnderwritingRequirementsApiFp(configuration).getPendingUnderwritingRequirements(version, agentNumbers, isNewYork, exportToCsv, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pendingUnderwritingRequirementsPendingUnderwritingRequirementResetETL(version: string, options?: any): AxiosPromise<void> {
            return PendingUnderwritingRequirementsApiFp(configuration).pendingUnderwritingRequirementsPendingUnderwritingRequirementResetETL(version, options)(axios, basePath);
        },
    };
};

/**
 * PendingUnderwritingRequirementsApi - object-oriented interface
 * @export
 * @class PendingUnderwritingRequirementsApi
 * @extends {BaseAPI}
 */
export class PendingUnderwritingRequirementsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {Array<string>} [agentNumbers] 
     * @param {boolean} [isNewYork] 
     * @param {boolean} [exportToCsv] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PendingUnderwritingRequirementsApi
     */
    public getPendingUnderwritingRequirements(version: string, agentNumbers?: Array<string>, isNewYork?: boolean, exportToCsv?: boolean, options?: any) {
        return PendingUnderwritingRequirementsApiFp(this.configuration).getPendingUnderwritingRequirements(version, agentNumbers, isNewYork, exportToCsv, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PendingUnderwritingRequirementsApi
     */
    public pendingUnderwritingRequirementsPendingUnderwritingRequirementResetETL(version: string, options?: any) {
        return PendingUnderwritingRequirementsApiFp(this.configuration).pendingUnderwritingRequirementsPendingUnderwritingRequirementResetETL(version, options)(this.axios, this.basePath);
    }

}


/**
 * PoliciesApi - axios parameter creator
 * @export
 */
export const PoliciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPoliciesToCsv(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling exportPoliciesToCsv.');
            }
            const localVarPath = `/api/policies/v{version}/csv`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesPolicyETL(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling policiesPolicyETL.');
            }
            const localVarPath = `/api/policies/v{version}/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesPolicyResetETL(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling policiesPolicyResetETL.');
            }
            const localVarPath = `/api/policies/v{version}/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPolicies(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchPolicies.');
            }
            const localVarPath = `/api/policies/v{version}/policies`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoliciesApi - functional programming interface
 * @export
 */
export const PoliciesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPoliciesToCsv(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = PoliciesApiAxiosParamCreator(configuration).exportPoliciesToCsv(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesPolicyETL(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = PoliciesApiAxiosParamCreator(configuration).policiesPolicyETL(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesPolicyResetETL(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = PoliciesApiAxiosParamCreator(configuration).policiesPolicyResetETL(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPolicies(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfPolicyDto> {
            const localVarAxiosArgs = PoliciesApiAxiosParamCreator(configuration).searchPolicies(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PoliciesApi - factory interface
 * @export
 */
export const PoliciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPoliciesToCsv(version: string, options?: any): AxiosPromise<any> {
            return PoliciesApiFp(configuration).exportPoliciesToCsv(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesPolicyETL(version: string, options?: any): AxiosPromise<void> {
            return PoliciesApiFp(configuration).policiesPolicyETL(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesPolicyResetETL(version: string, options?: any): AxiosPromise<void> {
            return PoliciesApiFp(configuration).policiesPolicyResetETL(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPolicies(version: string, options?: any): AxiosPromise<PagedResultOfPolicyDto> {
            return PoliciesApiFp(configuration).searchPolicies(version, options)(axios, basePath);
        },
    };
};

/**
 * PoliciesApi - object-oriented interface
 * @export
 * @class PoliciesApi
 * @extends {BaseAPI}
 */
export class PoliciesApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public exportPoliciesToCsv(version: string, options?: any) {
        return PoliciesApiFp(this.configuration).exportPoliciesToCsv(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesPolicyETL(version: string, options?: any) {
        return PoliciesApiFp(this.configuration).policiesPolicyETL(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesPolicyResetETL(version: string, options?: any) {
        return PoliciesApiFp(this.configuration).policiesPolicyResetETL(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public searchPolicies(version: string, options?: any) {
        return PoliciesApiFp(this.configuration).searchPolicies(version, options)(this.axios, this.basePath);
    }

}


/**
 * PolicyApplicationsApi - axios parameter creator
 * @export
 */
export const PolicyApplicationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} appId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyApplicationsGetPolicyApplicationImageById(appId: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId','Required parameter appId was null or undefined when calling policyApplicationsGetPolicyApplicationImageById.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling policyApplicationsGetPolicyApplicationImageById.');
            }
            const localVarPath = `/api/policies/v{version}/applications/{appId}`
                .replace(`{${"appId"}}`, encodeURIComponent(String(appId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyApplicationsPolicyApplicationResetETL(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling policyApplicationsPolicyApplicationResetETL.');
            }
            const localVarPath = `/api/policies/v{version}/applications/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPolicyApplications(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchPolicyApplications.');
            }
            const localVarPath = `/api/policies/v{version}/applications`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PolicyApplicationsApi - functional programming interface
 * @export
 */
export const PolicyApplicationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} appId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyApplicationsGetPolicyApplicationImageById(appId: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = PolicyApplicationsApiAxiosParamCreator(configuration).policyApplicationsGetPolicyApplicationImageById(appId, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyApplicationsPolicyApplicationResetETL(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = PolicyApplicationsApiAxiosParamCreator(configuration).policyApplicationsPolicyApplicationResetETL(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPolicyApplications(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfPolicyApplicationDto> {
            const localVarAxiosArgs = PolicyApplicationsApiAxiosParamCreator(configuration).searchPolicyApplications(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PolicyApplicationsApi - factory interface
 * @export
 */
export const PolicyApplicationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} appId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyApplicationsGetPolicyApplicationImageById(appId: string, version: string, options?: any): AxiosPromise<string> {
            return PolicyApplicationsApiFp(configuration).policyApplicationsGetPolicyApplicationImageById(appId, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyApplicationsPolicyApplicationResetETL(version: string, options?: any): AxiosPromise<void> {
            return PolicyApplicationsApiFp(configuration).policyApplicationsPolicyApplicationResetETL(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPolicyApplications(version: string, options?: any): AxiosPromise<PagedResultOfPolicyApplicationDto> {
            return PolicyApplicationsApiFp(configuration).searchPolicyApplications(version, options)(axios, basePath);
        },
    };
};

/**
 * PolicyApplicationsApi - object-oriented interface
 * @export
 * @class PolicyApplicationsApi
 * @extends {BaseAPI}
 */
export class PolicyApplicationsApi extends BaseAPI {
    /**
     * 
     * @param {string} appId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApplicationsApi
     */
    public policyApplicationsGetPolicyApplicationImageById(appId: string, version: string, options?: any) {
        return PolicyApplicationsApiFp(this.configuration).policyApplicationsGetPolicyApplicationImageById(appId, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApplicationsApi
     */
    public policyApplicationsPolicyApplicationResetETL(version: string, options?: any) {
        return PolicyApplicationsApiFp(this.configuration).policyApplicationsPolicyApplicationResetETL(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApplicationsApi
     */
    public searchPolicyApplications(version: string, options?: any) {
        return PolicyApplicationsApiFp(this.configuration).searchPolicyApplications(version, options)(this.axios, this.basePath);
    }

}


/**
 * ProcessLogsApi - axios parameter creator
 * @export
 */
export const ProcessLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getLatestEtlStatuses.');
            }
            const localVarPath = `/api/policies/v{version}/processlogs/latest`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessLogsApi - functional programming interface
 * @export
 */
export const ProcessLogsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessLogDto>> {
            const localVarAxiosArgs = ProcessLogsApiAxiosParamCreator(configuration).getLatestEtlStatuses(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessLogsApi - factory interface
 * @export
 */
export const ProcessLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options?: any): AxiosPromise<Array<ProcessLogDto>> {
            return ProcessLogsApiFp(configuration).getLatestEtlStatuses(version, options)(axios, basePath);
        },
    };
};

/**
 * ProcessLogsApi - object-oriented interface
 * @export
 * @class ProcessLogsApi
 * @extends {BaseAPI}
 */
export class ProcessLogsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessLogsApi
     */
    public getLatestEtlStatuses(version: string, options?: any) {
        return ProcessLogsApiFp(this.configuration).getLatestEtlStatuses(version, options)(this.axios, this.basePath);
    }

}


/**
 * ServiceRequestsApi - axios parameter creator
 * @export
 */
export const ServiceRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {SendPolicyServiceRequestChangeCommand} serviceRequestChange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail(version: string, serviceRequestChange: SendPolicyServiceRequestChangeCommand, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling sendEmail.');
            }
            // verify required parameter 'serviceRequestChange' is not null or undefined
            if (serviceRequestChange === null || serviceRequestChange === undefined) {
                throw new RequiredError('serviceRequestChange','Required parameter serviceRequestChange was null or undefined when calling sendEmail.');
            }
            const localVarPath = `/api/policies/v{version}/serviceRequests/sendEmail`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof serviceRequestChange !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(serviceRequestChange !== undefined ? serviceRequestChange : {}) : (serviceRequestChange || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceRequestsApi - functional programming interface
 * @export
 */
export const ServiceRequestsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {SendPolicyServiceRequestChangeCommand} serviceRequestChange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail(version: string, serviceRequestChange: SendPolicyServiceRequestChangeCommand, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ServiceRequestsApiAxiosParamCreator(configuration).sendEmail(version, serviceRequestChange, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ServiceRequestsApi - factory interface
 * @export
 */
export const ServiceRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {SendPolicyServiceRequestChangeCommand} serviceRequestChange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail(version: string, serviceRequestChange: SendPolicyServiceRequestChangeCommand, options?: any): AxiosPromise<void> {
            return ServiceRequestsApiFp(configuration).sendEmail(version, serviceRequestChange, options)(axios, basePath);
        },
    };
};

/**
 * ServiceRequestsApi - object-oriented interface
 * @export
 * @class ServiceRequestsApi
 * @extends {BaseAPI}
 */
export class ServiceRequestsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {SendPolicyServiceRequestChangeCommand} serviceRequestChange 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestsApi
     */
    public sendEmail(version: string, serviceRequestChange: SendPolicyServiceRequestChangeCommand, options?: any) {
        return ServiceRequestsApiFp(this.configuration).sendEmail(version, serviceRequestChange, options)(this.axios, this.basePath);
    }

}


